import type { MouseEvent } from 'react'
import SingleStory from './SingleStory'
import StoryFeedViewer from './StoryFeedViewer'
import type { StoryViewerTarget } from './StoryViewerContext'
import styles from './StoryViewer.module.css'

export interface StoryViewerProps {
	target: StoryViewerTarget
	onClose: () => void
}

export default function StoryViewer({ target, onClose }: StoryViewerProps) {
	if (target.type === 'PERSONAL_STORIES') {
		return (
			<StoryFeedViewer
				username={target.username}
				participantUsernames={target.participantUsernames}
				onClose={onClose}
			/>
		)
	}

	const handleBackdropClick = (event: MouseEvent<HTMLDivElement>) => {
		if (event.target === event.currentTarget) onClose()
	}

	return (
		<div className={styles.root} onClick={handleBackdropClick}>
			<SingleStory storyId={target.storyId} onClose={onClose} />
		</div>
	)
}
